export default "__VITE_ASSET__c0de17b7__"